export const AUDIT_TRAIL_COLUMN_HEADERS = {
  employeeId: { label: 'Employee ID', field: 'employeeId' },
  name: { label: 'Name', field: 'name' },
  role: { label: 'Role', field: 'role' },
  action: { label: 'Action', field: 'action' },
  date: { label: 'Date', field: 'date' },
};
export const FOLLOWUP_REPORT_COLUMN_HEADERS = {
  title: { label: 'Title', field: 'title' },
  eventId: { label: 'Report ID', field: 'eventId' },
  eventCategory: { label: 'Event Category', field: 'eventCategory' },
  eventType: { label: 'Event Type', field: 'eventType' },
  eventStartTime: {
    label: 'Incident Start Time',
    field: 'eventStartTime',
  },
  eventFinishTime: {
    label: 'Incident Finish Time',
    field: 'eventFinishTime',
  },
};

export const AuditTableColumns = [
  {
    headerName: AUDIT_TRAIL_COLUMN_HEADERS.employeeId.label,
    field: AUDIT_TRAIL_COLUMN_HEADERS.employeeId.field,
  },
  {
    headerName: AUDIT_TRAIL_COLUMN_HEADERS.name.label,
    field: AUDIT_TRAIL_COLUMN_HEADERS.name.field,
  },
  {
    headerName: AUDIT_TRAIL_COLUMN_HEADERS.role.label,
    field: AUDIT_TRAIL_COLUMN_HEADERS.role.field,
    cellRenderer: 'roleArray',
  },
  {
    headerName: AUDIT_TRAIL_COLUMN_HEADERS.action.label,
    field: AUDIT_TRAIL_COLUMN_HEADERS.action.field,
  },
  {
    headerName: AUDIT_TRAIL_COLUMN_HEADERS.date.label,
    field: AUDIT_TRAIL_COLUMN_HEADERS.date.field,
  },
];

export const FollowupReprtTableColumns = [
  {
    headerName: FOLLOWUP_REPORT_COLUMN_HEADERS.title.label,
    field: FOLLOWUP_REPORT_COLUMN_HEADERS.title.field,
  },
  {
    headerName: FOLLOWUP_REPORT_COLUMN_HEADERS.eventId.label,
    field: FOLLOWUP_REPORT_COLUMN_HEADERS.eventId.field,
  },
  {
    headerName: FOLLOWUP_REPORT_COLUMN_HEADERS.eventCategory.label,
    field: FOLLOWUP_REPORT_COLUMN_HEADERS.eventCategory.field,
  },
  {
    headerName: FOLLOWUP_REPORT_COLUMN_HEADERS.eventType.label,
    field: FOLLOWUP_REPORT_COLUMN_HEADERS.eventType.field,
  },
  {
    headerName: FOLLOWUP_REPORT_COLUMN_HEADERS.eventStartTime.label,
    field: FOLLOWUP_REPORT_COLUMN_HEADERS.eventStartTime.field,
    cellRenderer: 'convertStartTime',
  },
  {
    headerName: FOLLOWUP_REPORT_COLUMN_HEADERS.eventFinishTime.label,
    field: FOLLOWUP_REPORT_COLUMN_HEADERS.eventFinishTime.field,
    cellRenderer: 'convertFinishTime',
  },
];
